import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const FIELD_LABELS = {
  full_name: "Full name", email: "Email", company: "Company", job_title: "Job title", description: "Description",
  profile_url: "Profile URL", years_experience: "Years of experience",
};

export function formatApiError(err) {
  if (!err?.response) return "We could not reach the server. Please check your connection and try again.";
  const detail = err.response.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => {
        const field = Array.isArray(e?.loc) ? e.loc[e.loc.length - 1] : "";
        const msg = (e?.msg || "").replace(/^Value error, /, "");
        return FIELD_LABELS[field] ? `${FIELD_LABELS[field]}: ${msg}` : msg;
      })
      .join(" ");
  }
  return "Something went wrong. Please try again.";
}

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
